import React from "react";
import { Paper, Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%"
  },
  addAppContainer: theme.mixins.dashedBorder
}));

export default function NewItem(props) {
  const classes = useStyles();
  const { onAddAppClick } = props;
  return (
    <Paper className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        zIndex={1}
        alignItems="stretch"
        height="100%"
        padding={1}
      >
        <Box className={classes.addAppContainer} width="100%" height="100%">
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            height="100%"
          >
            <Button color="primary" onClick={onAddAppClick}>
              <AddIcon color="primary" />
              Add an App
            </Button>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}

NewItem.propTypes = {
  onAddAppClick: PropTypes.func
};
